export default __webpack_public_path__ + "static/media/73.28ea03f5.jpg";